// import "./debug_gui.js";
import * as THREE from "three";
import ThreeMeshUI from "three-mesh-ui";
import { loader } from "./loader.js";
import { onResize } from "./resize.js";
import { initRaycaster } from "./raycaster.js";
import { makeCSS2Dannotaition, initCSS2DRenderer } from "./annotations.js";
import { animations } from "./animations.js";
import { materials } from "./materials.js";
import { sceneHandler, setShadowBehaviour } from "./scene.js";
import * as Camera from "./Camera.js";
import { EffectComposer, RenderPass } from "postprocessing";

import BuildingWithDragControls from "./BuildingWithDragControls.js";

import GuideLines from "./GuideLines.js";

import "./htmlListeners.js";
import { cloneWidthSide, mirrorCloneX } from "./cloneObject.js";
import { setTableDefaultColor } from "./changeMaterialColor.js";
import { loadPage } from "../helpers/loadPage.js";
import { createLinkWithPath } from "../helpers/createLinkWithPath.js";
import { applyAOTexturesToGLB } from "../helpers/loadGLB.js";
import { wrapedAllObjectInAllArr } from "../helpers/wrapMeshInGroup.js";
import { getConfigOnServ, getPdfData, getPrice } from "../helpers/api.js";
import { loadJSON } from "./saveLoad.js";
import { updatePrice } from "../helpers/updatePrice.js";
import Tips from "./tips";

// Кэш для AO-текстур: имён файлов и загруженных объектов THREE.Texture
// const aoTextureCache = {
//     names: new Set(), // уникальные имена AO-файлов
//     textures: null, // массив загруженных текстур
//     map: {}, // имя → THREE.Texture
//     loaded: false, // флаг, что загрузка уже выполнена
// };

// /**
//  * Загружает все AO-текстуры единовременно через loader.loadTextures.
//  * Результаты сохраняются в servObj.aoTextureCache.map по имени файла.
//  *
//  * @param {string} basePath - путь до директории с текстурами, например '/textures'.
//  * @returns {Promise<void>} разрешается после загрузки всех текстур.
//  */
// function loadAllAOTextures(basePath) {
//     return new Promise((resolve, reject) => {
//         const namesArray = Array.from(servObj.aoTextureCache.names);
//         loader.loadTextures(
//             basePath,
//             namesArray,
//             (textures) => {
//                 servObj.aoTextureCache.textures = textures;
//                 namesArray.forEach((name, idx) => {
//                     servObj.aoTextureCache.map[name] = textures[idx];
//                 });
//                 servObj.aoTextureCache.loaded = true;
//                 resolve();
//             },
//             undefined,
//             (err) => {
//                 console.error("Ошибка загрузки AO-текстур:", err);
//                 reject(err);
//             },
//         );
//     });
// }

// /**
//  * Применяет AO-текстуры ко всем объектам GLB-сцены.
//  * Загружает каждый AO-файл один раз, затем переиспользует текстуру из кэша.
//  *
//  * @async
//  * @param {THREE.Object3D} glb - корневой Object3D из GLTFLoader.
//  * @param {string} basePath - путь к папке с AO-текстурами (дефолт '/textures').
//  */
// async function applyAOTexturesToGLB(glb, basePath = "textures") {
//     console.warn(basePath);
//     // 1) Сбор уникальных имён AO-файлов из userData
//     servObj.aoTextureCache.names.clear();
//     glb.traverse((obj) => {
//         if (obj.userData?.ao) {
//             servObj.aoTextureCache.names.add(obj.userData.ao);
//         }
//     });

//     // 2) Разовая загрузка всех AO-текстур
//     if (!servObj.aoTextureCache.loaded && servObj.aoTextureCache.names.size > 0) {
//         await loadAllAOTextures(basePath);
//     }

//     // 3) Назначение AO-карт материалам
//     glb.traverse((obj) => {
//         const aoName = obj.userData?.ao;
//         if (!aoName) return;

//         const texture = servObj.aoTextureCache.map[aoName];
//         if (!texture) return;

//         const applyToMaterial = (material) => {
//             material.aoMap = texture;
//             material.needsUpdate = true;
//         };

//         if (obj.material) {
//             if (Array.isArray(obj.material)) {
//                 obj.material.forEach(applyToMaterial);
//             } else {
//                 applyToMaterial(obj.material);
//             }
//         } else {
//             obj.children.forEach((child) => {
//                 if (child.material) {
//                     if (Array.isArray(child.material)) child.material.forEach(applyToMaterial);
//                     else applyToMaterial(child.material);
//                 }
//             });
//         }
//     });
// }

const container3D = document.querySelector(".d3d-container");
const foreground = document.querySelector(".foreground");
const globalLoader = document.getElementById("global-loader");

let composer, renderPass;
const renderer = new THREE.WebGLRenderer({
    antialias: true,
    outputColorSpace: THREE.SRGBColorSpace,
    stencil: true,
});
// renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.shadowMap.enabled = true;
// renderer.shadowMap.type = THREE.VSMShadowMap; //PCFSoftShadowMap
const canvas = renderer.domElement;
container3D.appendChild(canvas);
renderer.setSize(container3D.offsetWidth, container3D.offsetHeight);
renderer.localClippingEnabled = true;
renderer.setPixelRatio(devicePixelRatio);

window.container3D = container3D;
window.container3D.foreground = foreground;
container3D.foreground.style.opacity = 1;
window.container3D.canvas = canvas;

const annRenderer = initCSS2DRenderer(container3D);
servObj.rendererAnn = annRenderer;
const scene = new THREE.Scene();
scene.background = new THREE.Color(0xffffff);
// scene.fog = new THREE.Fog(new THREE.Color(0xffffff), 60, 150);
// const bgFolder = gui.addFolder("Background");
// bgFolder.addColor(scene, "background");
// bgFolder.addColor(scene.fog, "color");
// bgFolder.add(scene.fog, "near");
// bgFolder.add(scene.fog, "far");

servObj.renderer = renderer;
servObj.scene = scene;

const myFov = 58.979709269937395;
const myAspect = 1.1441441441441442;

let activeCamera;
let building;

const width = 100 / 5; //window.innerWidth
const height = 100 / 5; //window.innerHeight

const orthoCamera = new Camera.Orthographic(
    container3D.canvas,
    width / -2,
    width / 2,
    height / 2,
    height / -2,
    1,
    1000,
);

const perspectiveCamera = new Camera.Perspective(container3D.canvas, myFov, myAspect);

scene.orthoCamera = orthoCamera;
scene.perspectiveCamera = perspectiveCamera;

scene.setActiveCamera = (camera) => {
    activeCamera = camera;
    scene.activeCamera = camera;
    renderPass.camera = activeCamera;

    onResize(scene.activeRenderer, activeCamera, container3D);
    onResize(annRenderer, activeCamera, container3D);
};
scene.activeRenderer = renderer;
scene.renderer = renderer;
scene.composer = null;

servObj.active = null;

const to2dView = () => {
    activeCamera = orthoCamera;

    scene.setActiveCamera(activeCamera);

    activeCamera.controls.setLookAt(0, 5, 0, 0, 0, 0);
    activeCamera.controls.azimuthRotateSpeed = 0;
    activeCamera.controls.polarRotateSpeed = 0;

    building.setWallsHiderMode("2D");
    building.changeCamera(activeCamera, scene.activeRenderer);
};
const to3dView = () => {
    const isEditMode = servObj.isEditMode;

    activeCamera = perspectiveCamera;

    const importedCameraTarget = scene.getObjectByName("camera_target");

    activeCamera.controls.setLookAt(
        -11.54551523854972,
        6.588234921725335,
        11.769283150943561,
        importedCameraTarget.position.x,
        importedCameraTarget.position.y,
        importedCameraTarget.position.z,
    );

    activeCamera.controls.minPolarAngle = 0;
    activeCamera.controls.maxPolarAngle = Math.PI / 2;

    const minY = isEditMode ? 10 : 0; // Минимальная высота камеры
    const boundary = new THREE.Box3(
        new THREE.Vector3(-Infinity, minY, -Infinity), // min: не ниже пола
        new THREE.Vector3(Infinity, Infinity, Infinity), // max: без ограничений вверх
    );
    activeCamera.controls.setBoundary(boundary);
    activeCamera.controls.boundaryEnclosesCamera = true;

    building.hideWall("wall_bot");
    building.hideWall("wall_left");

    scene.setActiveCamera(activeCamera);
    building.setWallsHiderMode("3D");
    building.changeCamera(activeCamera, scene.activeRenderer);

    document.querySelector(".twoD").classList.remove("active");
    document.querySelector(".threeD").classList.add("active");

    servObj.is2dView = false;

    // if (isShowSizes) building.showHeightSize();
};

const loadElements = new Promise((resolve) => {
    loader.loadGLTF("./3d/elementi.glb", async (gltf) => {
        const glb = gltf.scene;
        const glbName = "elementi.glb";
        const link = createLinkWithPath("textures");

        glb.traverse((el) => {
            if (el.material) el.material = el.material.clone();
            el.visible = false;
        });

        glb.children.forEach((el) => (el.userData.glbName = glbName));

        applyAOTexturesToGLB(glb, link);

        scene.add(glb);
        scene.animations = gltf.animations;

        //Init block
        animations.initHandler(scene);
        activeCamera = scene.perspectiveCamera;
        activeCamera.fov = myFov;
        activeCamera.aspect = myAspect;
        activeCamera.name = "camera";

        initRaycaster(scene, activeCamera);

        onResize(renderer, activeCamera, container3D);
        onResize(annRenderer, activeCamera, container3D);

        window.addEventListener("resize", () => onResize(scene.activeRenderer, activeCamera, container3D));
        window.addEventListener("resize", () => onResize(annRenderer, activeCamera, container3D));

        composer = new EffectComposer(renderer, { multisampling: 8, stencilBuffer: true });
        renderPass = new RenderPass(scene, activeCamera);
        composer.addPass(renderPass);

        scene.composer = composer;
        // gui.add(scene, "activeRenderer", { renderer: scene.renderer, composer: scene.composer });

        sceneHandler.init(scene);

        resolve(glb);

        animate();
        animations.fadeIn();

        document.querySelector(".twoD").addEventListener("pointerdown", () => {
            //if(is2dView) return
            to2dView();
            servObj.is2dView = true;
            document.querySelector(".twoD").classList.add("active");
            document.querySelector(".threeD").classList.remove("active");
            if (servObj.isShowSizes) building.hideHeightSize();
        });
        document.querySelector(".threeD").addEventListener("pointerdown", to3dView);

        building.hideHeightSize();
        building.hideBuildingSize();

        /*********** ЗАПОЛНЕНИЕ МАССИВОВ ОБЪЕКТОВ ***************/
        const tableCoverArr = ["dopolnitelnoe_pokritie_stoleshnitsi"];
        const tableStops = ["ogranichitel_bokovoi__stol", "ogranichitel_zadnii__stol"];
        const cornerTable = ["uglovoy_stol"];
        const polka_nizhnyaya = ["polka_nizhnyaya"];
        const bokovaya_pristavka = ["bokovaya_pristavka"];
        const tableTumba = ["tumba_podvesnaya"];
        const podstavka_pod_sistemnii_blok = ["podstavka_pod_sistemnii_blok"];
        const keyShelf = ["polka_dlya_klaviaturi"];
        const lotokDlyaProvodov = ["lotok_dlya_provodov"];
        const podstavkaPodNogi = ["podstavka_pod_nogi"];
        const komplektStoek = ["komplekt_stoek"];
        const polka_dlya_kantselyarskikh_prinadlezhnostei = ["polka_dlya_kantselyarskikh_prinadlezhnostei"];
        const polka_vidvizhnaya_pod_orgtekhniku = ["polka_vidvizhnaya_pod_orgtekhniku"];
        const polka_dlya_klaviaturi = ["polka_dlya_klaviaturi"];
        const konteiner_dlya_rabochikh_otkhodov = ["konteiner_dlya_rabochikh_otkhodov"];
        const polka_pribornaya = ["polka_pribornaya"];
        const osveshchenie_verkhnee = ["osveshchenie_verkhnee"];
        const osveshchenie_pod_pribornuyu = ["osveshchenie_pod_pribornuyu"];
        const osveshchenie_bokovoe = ["osveshchenie_bokovoe"];
        const perfopanel = ["perfopanel"];
        const panel_elektromontazhnaya = ["panel_elektromontazhnaya"];
        const lotok_metallicheskii = ["lotok_metallicheskii"];
        const planka_dlya_lotkov = ["planka_dlya_lotkov"];
        const rama_razdelitelnaya = ["rama_razdelitelnaya"];
        const derzhatel_monitora = ["derzhatel_monitora"];
        const elektropanel = ["elektropanel"];
        const polka_dlya_klaviaturi_i_mishi = ["polka_dlya_klaviaturi_i_mishi"];
        const kronshtein_dlya_printera = ["kronshtein_dlya_printera"];
        const podstavka_dlya_chertezhei = ["podstavka_dlya_chertezhei"];
        const instrumentalnaya_planka = ["instrumentalnaya_planka"];
        const yashchik_dlya_melkikh_komplektuyushchikh__plastik = ["yashchik_dlya_melkikh_komplektuyushchikh__plastik"];
        const yashchik_dlya_melkikh_komplektuyushchikh__metall = ["yashchik_dlya_melkikh_komplektuyushchikh__metall"];
        const derzhatel_rulona__nizhnii = ["derzhatel_rulona__nizhnii"];
        const derzhatel_rulona__verkhnii = ["derzhatel_rulona__verkhnii"];
        const fiksator_rulonnikh_materialov = ["fiksator_rulonnikh_materialov"];
        const derzhatel_rulona__bokovoi = ["derzhatel_rulona__bokovoi"];
        const rezak_rulonnikh_materialov = ["rezak_rulonnikh_materialov"];

        servObj.scene.traverse((el) => {
            if (el.name.includes("mesh") || el.name.includes("hitbox")) return;
            if (el.name.includes("hitbox")) el.visible = false;
            // TABLE COVER
            if (tableCoverArr.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allTableCover";
                el.userData.activeFolderName = "activeTableCover";
                el.userData.isBottom = true;
                servObj.allTableCover.push(el);
            }

            // ОГРАНИЧИТЕЛИ СТОЛА
            if (tableStops.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allTableStops";
                el.userData.activeFolderName = "activeTableStops";
                el.userData.isBottom = true;
                servObj.allTableStops.push(el);
            }

            // УГЛОВОЙ СТОЛ -
            if (cornerTable.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allCornerTable";
                el.userData.activeFolderName = "activeCornerTable";
                el.userData.isBottom = true;
                servObj.allCornerTable.push(el);
            }

            // ПОЛКА НИЖНЯЯ
            if (
                polka_nizhnyaya.some(
                    (substr) =>
                        el.name.includes(substr) &&
                        !el.name.includes("mesh") &&
                        !el.name.includes("ogranichitel") &&
                        !el.name.includes("razdelitel"),
                )
            ) {
                el.userData.allFolderName = "allShelfDownSide";
                el.userData.activeFolderName = "activeShelfDownSide";
                el.userData.isBottom = true;
                servObj.allShelfDownSide.push(el);
            }

            // БОКОВАЯ ПРИСТАВКА
            if (bokovaya_pristavka.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const [name, type, size] = el.name.split("__");
                const newName = `${name}__${type}__left__${size}`;
                el.name = newName;
                el.userData.isBottom = true;
                el.userData.name = newName;

                const rightAnnex = mirrorCloneX(el, el.name);

                rightAnnex.userData.allFolderName = el.userData.allFolderName = "allTableAnnex";
                rightAnnex.userData.activeFolderName = el.userData.activeFolderName = "activeTableAnnex";
                rightAnnex.userData.isBottom = true;
                rightAnnex.userData.name = rightAnnex.name;

                servObj.allTableAnnex.push(el, rightAnnex);
            }

            // ТУМБА
            if (
                tableTumba.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh") && !el.name.includes("key"),
                )
            ) {
                ("tumba_podvesnaya__2_2_yashchik");

                const [name, size, depth] = el.name.split("__");

                const newName = `${name}__${size}__left__${depth}`;
                el.name = newName;
                el.userData.name = newName;

                const rightTumba = mirrorCloneX(el, newName);

                el.userData.allFolderName = "allTumbaLeft";
                el.userData.activeFolderName = "activeTumbaLeft";
                el.userData.isBottom = true;

                rightTumba.userData.allFolderName = "allTumbaRight";
                rightTumba.userData.activeFolderName = "activeTumbaRight";
                rightTumba.userData.isBottom = true;
                rightTumba.userData.name = rightTumba.name;

                servObj.allTumbaLeft.push(el);
                servObj.allTumbaRight.push(rightTumba);
            }

            // ПОДСТАВКА ПОД СИСТЕМНЫЙ БЛОК
            if (podstavka_pod_sistemnii_blok.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const newName = el.name.includes("podkatnaya")
                    ? "podstavka_pod_sistemnii_blok__left__podkatnaya"
                    : "podstavka_pod_sistemnii_blok__left__podvesnaya";

                el.name = newName;

                const rightPodstavka = mirrorCloneX(el, newName);

                rightPodstavka.userData.allFolderName = el.userData.allFolderName = "allPodstavkaPodSistemniiBlok";
                rightPodstavka.userData.activeFolderName = el.userData.activeFolderName =
                    "activePodstavkaPodSistemniiBlok";
                rightPodstavka.userData.position = el.userData.position = "bottom";

                servObj.allPodstavkaPodSistemniiBlok.push(el);
                servObj.allPodstavkaPodSistemniiBlok.push(rightPodstavka);
            }

            // ПОЛКА ДЛЯ КЛАВИАТУРЫ
            if (
                keyShelf.some((substr) => el.name.includes(substr) && !el.name.includes("mesh")) &&
                !el.name.includes("mishi")
            ) {
                const [name, size] = el.name.split("__");
                const newName = `${name}__left__${size}`;

                const right = mirrorCloneX(el, newName);

                right.userData.allFolderName = el.userData.allFolderName = "allKeyShelf";
                right.userData.activeFolderName = el.userData.activeFolderName = "activeKeyShelf";

                el.userData.isBottom = true;
                right.userData.isBottom = true;

                el.userData.name = newName;
                right.userData.name = right.name;

                servObj.allKeyShelf.push(el);
            }

            // КОМПЛЕКТ СТОЕК
            if (
                komplektStoek.some(
                    (substr) =>
                        el.name.includes(substr) &&
                        !el.name.includes("mesh") &&
                        !el.name.includes("verstak") &&
                        !el.name.includes("krepleniya"),
                )
            ) {
                el.userData.allFolderName = "allKomplektStoek";
                el.userData.activeFolderName = "activeKomplektStoek";
                el.userData.position = "bottom";
                el.userData.isBottom = "true";
                servObj.allKomplektStoek.push(el);
            }

            // ЛОТОК ДЛЯ ПРОВОДОВ
            if (lotokDlyaProvodov.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allLotokDlyaProvodov";
                el.userData.activeFolderName = "activeLotokDlyaProvodov";
                el.userData.isBottom = true;
                servObj.allLotokDlyaProvodov.push(el);
            }

            // ПОДСТАВКА ПОД НОГИ
            if (podstavkaPodNogi.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allPodstavkaPodNogi";
                el.userData.activeFolderName = "activePodstavkaPodNogi";
                el.userData.isBottom = true;
                servObj.allPodstavkaPodNogi.push(el);
            }

            // ПОЛКА ДЛЯ КАНЦЕЛЯРСКИХ ПРИНАДЛЕЖНОСТЕЙ
            if (
                polka_dlya_kantselyarskikh_prinadlezhnostei.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh"),
                )
            ) {
                const newName = "polka_dlya_kantselyarskikh_prinadlezhnostei__left";
                el.name = newName;

                let rightPolka = mirrorCloneX(el, newName);
                el.userData.isBottom = true;
                rightPolka.userData.isBottom = true;
                rightPolka.userData.allFolderName = el.userData.allFolderName =
                    "allPolkaDlyaKantselyarskikhPrinadlezhnostei";
                rightPolka.userData.activeFolderName = el.userData.activeFolderName =
                    "activePolkaDlyaKantselyarskikhPrinadlezhnostei";
                rightPolka.userData.position = el.userData.position = "bottom";
                el.userData.name = newName;
                rightPolka.userData.name = rightPolka.name;

                servObj.allPolkaDlyaKantselyarskikhPrinadlezhnostei.push(el, rightPolka);
            }
            // КОНТЕЙНЕР ДЛЯ РАБОЧИХ ОТХОДОВ
            if (
                konteiner_dlya_rabochikh_otkhodov.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh"),
                )
            ) {
                const newName = "konteiner_dlya_rabochikh_otkhodov__left";
                el.name = newName;
                el.userData.isBottom = true;
                el.userData.name = newName;

                const konteiner = mirrorCloneX(el, newName);
                konteiner.userData.isBottom = true;
                konteiner.userData.name = konteiner.name;

                konteiner.userData.allFolderName = el.userData.allFolderName = "allKonteinerDlyaRabochikhOtkhodov";
                konteiner.userData.activeFolderName = el.userData.activeFolderName =
                    "activeKonteinerDlyaRabochikhOtkhodov";
                konteiner.userData.position = el.userData.position = "bottom";
                servObj.allKonteinerDlyaRabochikhOtkhodov.push(el, konteiner);
            }

            // ПОЛКА ВЫДВИЖНАЯ ПОД ОРГТЕХНИКУ
            if (
                polka_vidvizhnaya_pod_orgtekhniku.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh"),
                )
            ) {
                const newName = "polka_vidvizhnaya_pod_orgtekhniku__left";
                el.name = newName;
                el.userData.isBottom = true;
                el.userData.name = newName;

                const rightPolka = mirrorCloneX(el, newName);
                rightPolka.userData.isBottom = true;
                rightPolka.userData.name = rightPolka.name;
                rightPolka.userData.allFolderName = el.userData.allFolderName = "allPolkaVidvizhnayaPodOrgtekhniku";
                rightPolka.userData.activeFolderName = el.userData.activeFolderName =
                    "activePolkaVidvizhnayaPodOrgtekhniku";
                rightPolka.userData.position = el.userData.position = "bottom";
                servObj.allPolkaVidvizhnayaPodOrgtekhniku.push(el, rightPolka);
            }

            // ПОЛКА ДЛЯ КЛАВИАТУРЫ
            if (
                polka_dlya_klaviaturi.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh") && !el.name.includes("mishi"),
                )
            ) {
                const [name, type] = el.name.split("__");
                const newName = `${name}__left__${type}`;
                el.name = newName;
                el.userData.name = newName;
                const rightPolka = mirrorCloneX(el, newName);
                rightPolka.userData.name = rightPolka.name;
                rightPolka.userData.allFolderName = el.userData.allFolderName = "allPolkaDlyaKlaviaturi";
                rightPolka.userData.activeFolderName = el.userData.activeFolderName = "activePolkaDlyaKlaviaturi";
                rightPolka.userData.position = el.userData.position = "bottom";
                servObj.allPolkaDlyaKlaviaturi.push(el, rightPolka);
            }

            // ПОЛКА ПРИБОРНАЯ
            if (
                polka_pribornaya.some(
                    (substr) =>
                        el.name.includes(substr) &&
                        !el.name.includes("mesh") &&
                        !el.name.includes("razdelitel") &&
                        !el.name.includes("hitbox") &&
                        !["600", "750", "900", "1000"].some((num) => el.name.includes(num)),
                )
            ) {
                el.userData.allFolderName = "allPolkaPribornaya";
                el.userData.activeFolderName = "activePolkaPribornaya";

                servObj.allPolkaPribornaya.push(el);
            }

            // ОСВЕЩЕНИЕ ВЕРХНЕЕ
            if (osveshchenie_verkhnee.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allOsveshchenieVerkhnee";
                el.userData.activeFolderName = "activeOsveshchenieVerkhnee";
                el.userData.position = "top";
                el.userData.name = el.name;
                servObj.allOsveshchenieVerkhnee.push(el);
            }

            // ОСВЕЩЕНИЕ ПОД ПРИБОРНУЮ ПОЛКУ
            if (osveshchenie_pod_pribornuyu.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                servObj.allPolkaPribornaya.forEach((polka) => {
                    if (polka.name.includes("dsp")) {
                        const newObject = el.clone();
                        newObject.userData.isChildren = true;
                        polka.attach(newObject);
                    }
                });
            }

            // ОСВЕЩЕНИЕ БОКОВОЕ
            if (osveshchenie_bokovoe.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const name = el.name.split("__");
                const newName = `${name}__left`;
                el.name = newName;
                el.userData.name = newName;

                const rightOsveshchenieBokovoe = mirrorCloneX(el, newName);
                rightOsveshchenieBokovoe.userData.name = rightOsveshchenieBokovoe.name;

                rightOsveshchenieBokovoe.userData.allFolderName = el.userData.allFolderName = "allOsveshchenieBokovoe";
                rightOsveshchenieBokovoe.userData.activeFolderName = el.userData.activeFolderName =
                    "activeOsveshchenieBokovoe";
                rightOsveshchenieBokovoe.userData.position = el.userData.position = "top";
                servObj.allOsveshchenieBokovoe.push(el, rightOsveshchenieBokovoe);
            }

            // ПЕРФОПАНЕЛЬ
            if (
                perfopanel.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh") && !el.name.includes("hitbox"),
                )
            ) {
                const name = el.name.split("__");
                const width = name[1].split("x")[0];
                let rightPerfopanel = null;

                const bsize = servObj.building.getBoundaryGeometry(el);

                if (width < 1200) {
                    const newName = `${name[0]}__left__${name[1]}`;
                    el.name = newName;
                    el.userData.name = newName;
                    rightPerfopanel = mirrorCloneX(el, newName);
                    rightPerfopanel.userData.name = rightPerfopanel.name;
                    rightPerfopanel.userData.allFolderName = "allPerfopanel";
                    rightPerfopanel.userData.activeFolderName = "activePerfopanel";
                    rightPerfopanel.userData.isHalfObj = true;
                    rightPerfopanel.userData.bsize = bsize;

                    el.userData.isHalfObj = true;
                }
                el.userData.bsize = bsize;

                el.userData.allFolderName = "allPerfopanel";
                el.userData.activeFolderName = "activePerfopanel";
                el.userData.position = "top";

                rightPerfopanel ? servObj.allPerfopanel.push(el, rightPerfopanel) : servObj.allPerfopanel.push(el);
            }

            // ПАНЕЛЬ ЭЛЕМКТРОМОНТАЖНАЯ
            if (panel_elektromontazhnaya.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const name = el.name.split("__");
                let rightPanelElektromontazhnaya = null;

                if (name[1] < 1200) {
                    const newName = `${name[0]}__left__${name[1]}`;
                    el.name = newName;
                    el.userData.name = newName;
                    rightPanelElektromontazhnaya = cloneWidthSide(el, newName);
                    rightPanelElektromontazhnaya.userData.name = rightPanelElektromontazhnaya.name;
                    rightPanelElektromontazhnaya.userData.allFolderName = "allPanelElektromontazhnaya";
                    rightPanelElektromontazhnaya.userData.activeFolderName = "activePanelElektromontazhnaya";
                }

                if (rightPanelElektromontazhnaya) {
                    rightPanelElektromontazhnaya.userData.allFolderName = el.userData.allFolderName =
                        "allPanelElektromontazhnaya";
                    rightPanelElektromontazhnaya.userData.activeFolderName = el.userData.activeFolderName =
                        "activePanelElektromontazhnaya";
                    rightPanelElektromontazhnaya.userData.position = el.userData.position = "top";
                    servObj.allPanelElektromontazhnaya.push(el, rightPanelElektromontazhnaya);
                } else {
                    el.userData.allFolderName = "allPanelElektromontazhnaya";
                    el.userData.activeFolderName = "activePanelElektromontazhnaya";
                    el.userData.position = "top";
                    servObj.allPanelElektromontazhnaya.push(el);
                }
            }

            // ЛОТОК МЕТАЛЛИЧЕСКИЙ
            if (
                lotok_metallicheskii.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh") && !el.name.includes("hitbox"),
                )
            ) {
                const name = el.name.split("__");
                let rightLotokMetallicheskii = null;
                const bsize = servObj.building.getBoundaryGeometry(el);
                if (name[1] < 1200) {
                    const newName = `${name[0]}__left__${name[1]}`;
                    el.name = newName;
                    el.userData.name = newName;
                    rightLotokMetallicheskii = mirrorCloneX(el, newName);
                    rightLotokMetallicheskii.userData.name = rightLotokMetallicheskii.name;
                    rightLotokMetallicheskii.userData.allFolderName = "allLotokMetallicheskii";
                    rightLotokMetallicheskii.userData.activeFolderName = "activeLotokMetallicheskii";
                    rightLotokMetallicheskii.userData.position = "top";
                    rightLotokMetallicheskii.userData.isHalfObj = true;
                    el.userData.isHalfObj = true;
                    rightLotokMetallicheskii.userData.bsize = bsize;
                }

                el.userData.allFolderName = "allLotokMetallicheskii";
                el.userData.activeFolderName = "activeLotokMetallicheskii";
                el.userData.position = "top";
                el.userData.bsize = bsize;

                rightLotokMetallicheskii
                    ? servObj.allLotokMetallicheskii.push(el, rightLotokMetallicheskii)
                    : servObj.allLotokMetallicheskii.push(el);
            }

            // ПЛАНКА ДЛЯ ЛОТКОВ
            if (planka_dlya_lotkov.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const name = el.name.split("__");
                let rightPlankaDlyaLotkov = null;

                if (name[1] < 1200) {
                    const newName = `${name[0]}__left__${name[1]}`;
                    el.name = newName;
                    el.userData.name = newName;
                    rightPlankaDlyaLotkov = mirrorCloneX(el, newName);
                    rightPlankaDlyaLotkov.userData.name = rightPlankaDlyaLotkov.name;
                    rightPlankaDlyaLotkov.userData.allFolderName = "allPlankaDlyaLotkov";
                    rightPlankaDlyaLotkov.userData.activeFolderName = "activePlankaDlyaLotkov";
                    const bsize = servObj.building.getBoundaryGeometry(el);
                    rightPlankaDlyaLotkov.userData.isHalfObj = true;
                    rightPlankaDlyaLotkov.userData.bsize = bsize;
                    el.userData.isHalfObj = true;
                    el.userData.bsize = bsize;
                }

                el.userData.allFolderName = "allPlankaDlyaLotkov";
                el.userData.activeFolderName = "activePlankaDlyaLotkov";
                el.userData.position = "top";
                rightPlankaDlyaLotkov
                    ? servObj.allPlankaDlyaLotkov.push(el, rightPlankaDlyaLotkov)
                    : servObj.allPlankaDlyaLotkov.push(el);
            }

            // ПОЛКА КОРОТКАЯ (ПОЛОВИННАЯ)
            if (
                polka_pribornaya.some(
                    (substr) =>
                        el.name.includes(substr) &&
                        !el.name.includes("mesh") &&
                        !el.name.includes("razdelitel") &&
                        !el.name.includes("hitbox") &&
                        el.name.includes("dsp") &&
                        ["600", "750", "900", "1000"].some((num) => el.name.includes(num)),
                )
            ) {
                el.name = el.name.replace("__dsp", "").replace("polka_pribornaya", "polka_korotkaya");
                const name = el.name.split("__");
                const newName = `${name[0]}__left__${name[1]}`;
                el.name = newName;
                el.userData.name = newName;

                const rightPolkaKorotkaya = mirrorCloneX(el, newName);

                rightPolkaKorotkaya.userData.name = rightPolkaKorotkaya.name;
                rightPolkaKorotkaya.userData.allFolderName = el.userData.allFolderName = "allPolkaKorotkaya";
                rightPolkaKorotkaya.userData.activeFolderName = el.userData.activeFolderName = "activePolkaKorotkaya";

                const bsize = servObj.building.getBoundaryGeometry(el);
                rightPolkaKorotkaya.userData.isHalfObj = true;
                rightPolkaKorotkaya.userData.bsize = bsize;
                el.userData.isHalfObj = true;
                el.userData.bsize = bsize;

                servObj.allPolkaKorotkaya.push(el, rightPolkaKorotkaya);
            }

            // ПОЛКА НАКЛОННАЯ (ПОЛОВИННАЯ)
            if (
                polka_pribornaya.some(
                    (substr) =>
                        el.name.includes(substr) &&
                        !el.name.includes("mesh") &&
                        !el.name.includes("razdelitel") &&
                        !el.name.includes("hitbox") &&
                        el.name.includes("metall") &&
                        ["600", "750", "900", "1000"].some((num) => el.name.includes(num)),
                )
            ) {
                el.name = el.name.replace("__metall", "").replace("polka_pribornaya", "polka_naklonnaya");
                const name = el.name.split("__");
                const newName = `${name[0]}__left__${name[1]}`;
                el.name = newName;
                el.userData.name = newName;
                const hitbox = el.children.find((child) => child.name.includes("hitbox"));

                const rightPolkaNaklonnaya = mirrorCloneX(el, newName);
                rightPolkaNaklonnaya.userData.name = rightPolkaNaklonnaya.name;

                rightPolkaNaklonnaya.userData.allFolderName = el.userData.allFolderName = "allPolkaNaklonnaya";
                rightPolkaNaklonnaya.userData.activeFolderName = el.userData.activeFolderName = "activePolkaNaklonnaya";
                rightPolkaNaklonnaya.userData.position = el.userData.position = "top";

                const bsize = servObj.building.getBoundaryGeometry(hitbox);
                rightPolkaNaklonnaya.userData.isHalfObj = true;
                rightPolkaNaklonnaya.userData.bsize = bsize;
                el.userData.isHalfObj = true;
                el.userData.bsize = bsize;

                servObj.allPolkaNaklonnaya.push(el, rightPolkaNaklonnaya);
            }

            // РАМА РАЗДЕЛИТЕЛЬНАЯ
            if (
                rama_razdelitelnaya.some(
                    (substr) =>
                        el.name.includes(substr) &&
                        !el.name.includes("mesh") &&
                        !el.name.includes("verstak") &&
                        !el.name.includes("krepleniya"),
                )
            ) {
                el.userData.allFolderName = "allRamaRazdelitelnaya";
                el.userData.activeFolderName = "activeRamaRazdelitelnaya";
                el.userData.position = "top";
                servObj.allRamaRazdelitelnaya.push(el);
            }

            // ДЕРЖАТЕЛЬ МОНИТОРА
            if (derzhatel_monitora.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const name = el.name.split("__");
                const newName = `${name[0]}__left__${name[1]}`;
                el.name = newName;
                el.userData.name = newName;

                const rightDerzhatelMonitora = mirrorCloneX(el, newName);

                rightDerzhatelMonitora.userData.name = rightDerzhatelMonitora.name;
                rightDerzhatelMonitora.userData.allFolderName = el.userData.allFolderName = "allDerzhatelMonitora";
                rightDerzhatelMonitora.userData.activeFolderName = el.userData.activeFolderName =
                    "activeDerzhatelMonitora";
                rightDerzhatelMonitora.userData.position = el.userData.position = "top";
                servObj.allDerzhatelMonitora.push(el, rightDerzhatelMonitora);
            }

            // ЭЛЕКТРОПАНЕЛЬ
            if (elektropanel.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allElektropanel";
                el.userData.activeFolderName = "activeElektropanel";
                el.userData.position = "top";
                servObj.allElektropanel.push(el);
            }

            // ПОЛКА ДЛЯ КЛАВИАТУРЫ И МЫШИ
            if (polka_dlya_klaviaturi_i_mishi.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const name = el.name.split("__");
                const newName = `${name}__left`;
                el.name = newName;
                el.userData.name = newName;

                const rightPolka = cloneWidthSide(el, newName);
                const rightPolkaBolt = rightPolka.children.find((el) => el.name.includes("bolt_ostrov"));
                rightPolkaBolt.scale.x *= -1;

                rightPolka.userData.name = rightPolka.name;
                rightPolka.userData.allFolderName = el.userData.allFolderName = "allPolkaDlyaKlaviaturiIMishi";
                rightPolka.userData.activeFolderName = el.userData.activeFolderName = "activePolkaDlyaKlaviaturiIMishi";
                rightPolka.userData.position = el.userData.position = "top";
                servObj.allPolkaDlyaKlaviaturiIMishi.push(el, rightPolka);
            }

            // КРОНШТЕЙН ДЛЯ ПРИНТЕРА
            if (kronshtein_dlya_printera.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const name = el.name.split("__");
                const newName = `${name}__left`;
                el.name = newName;
                el.userData.name = newName;

                const rightEl = mirrorCloneX(el, newName);

                rightEl.userData.name = rightEl.name;
                rightEl.userData.allFolderName = el.userData.allFolderName = "allKronshteinDlyaPrintera";
                rightEl.userData.activeFolderName = el.userData.activeFolderName = "activeKronshteinDlyaPrintera";
                rightEl.userData.position = el.userData.position = "top";
                servObj.allKronshteinDlyaPrintera.push(el, rightEl);
            }

            // ПОДСТАВКА ДЛЯ ЧЕРТЕЖЕЙ
            if (
                podstavka_dlya_chertezhei.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh") && !el.name.includes("hitbox"),
                )
            ) {
                const name = el.name.split("__");
                const newName = `${name}__left`;
                el.name = newName;
                el.userData.name = newName;

                const rightEl = mirrorCloneX(el, newName);

                rightEl.userData.name = rightEl.name;
                rightEl.userData.allFolderName = el.userData.allFolderName = "allPodstavkaDlyaChertezhei";
                rightEl.userData.activeFolderName = el.userData.activeFolderName = "activePodstavkaDlyaChertezhei";
                rightEl.userData.position = el.userData.position = "top";
                servObj.allPodstavkaDlyaChertezhei.push(el, rightEl);
            }

            // ИНСТРУМЕНТАЛЬНАЯ ПЛАНКА
            if (instrumentalnaya_planka.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                const width = el.name.split("__")[1];
                servObj.allOsveshchenieVerkhnee.forEach((item) => {
                    if (item.name.includes(width)) {
                        const newObject = el.clone();
                        item.attach(newObject);
                    }
                });
            }

            // Ящик для мелких комплектующих Пластик
            if (
                yashchik_dlya_melkikh_komplektuyushchikh__plastik.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh"),
                )
            ) {
                const newName = "yashchik_dlya_melkikh_komplektuyushchikh__plastik__left";
                el.name = newName;
                el.userData = {
                    isBottom: true,
                    position: "bottom",
                    allFolderName: "allYashchikMKPlastik",
                    activeFolderName: "activeYashchikMKPlastik",
                    name: newName,
                };

                const rightEl = mirrorCloneX(el, newName);
                rightEl.name = rightEl.name.replace("left", "right");
                rightEl.userData.name = rightEl.name;

                servObj.allYashchikMKPlastik.push(el, rightEl);
            }

            // Ящик для мелких комплектующих Пластик
            if (
                yashchik_dlya_melkikh_komplektuyushchikh__metall.some(
                    (substr) => el.name.includes(substr) && !el.name.includes("mesh"),
                )
            ) {
                const newName = "yashchik_dlya_melkikh_komplektuyushchikh__metall__left";
                el.name = newName;
                el.userData = {
                    isBottom: true,
                    position: "bottom",
                    allFolderName: "allYashchikMKMetall",
                    activeFolderName: "activeYashchikMKMetall",
                    name: newName,
                };

                const rightEl = mirrorCloneX(el, newName);
                rightEl.name = rightEl.name.replace("left", "right");
                rightEl.userData.name = rightEl.name;

                servObj.allYashchikMKMetall.push(el, rightEl);
            }

            // Держатель рулона (аксессуары нижние)
            if (derzhatel_rulona__nizhnii.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allDerzhatelRulonaNizhnii";
                el.userData.activeFolderName = "activeDerzhatelRulonaNizhnii";
                el.userData.position = "bottom";
                servObj.allDerzhatelRulonaNizhnii.push(el);
            }

            // Держатель рулона (верхние элементы)
            if (derzhatel_rulona__verkhnii.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allDerzhatelRulonaVerkhnii";
                el.userData.activeFolderName = "activeDerzhatelRulonaVerkhnii";
                el.userData.position = "top";
                const hitbox = el.children.find((child) => child.name.includes("hitbox"));
                const bsize = servObj.building.getBoundaryGeometry(hitbox);
                el.userData.bsize = bsize;

                if (Number(el.name.split("__").at(-1)) <= 1000) {
                    el.name += "__right";
                    const leftEl = mirrorCloneX(el, el.name);
                    leftEl.name = leftEl.name.replace("right", "left");
                    servObj.allDerzhatelRulonaVerkhnii.push(leftEl);
                }
                servObj.allDerzhatelRulonaVerkhnii.push(el);
            }

            if (fiksator_rulonnikh_materialov.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allFiksatorRulonnikhMaterialov";
                el.userData.activeFolderName = "activeFiksatorRulonnikhMaterialov";
                el.userData.position = "top";
                const hitbox = el.children.find((child) => child.name.includes("hitbox"));
                const bsize = servObj.building.getBoundaryGeometry(hitbox);
                el.userData.bsize = bsize;

                if (Number(el.name.split("__").at(-1)) <= 1000) {
                    el.name += "__left";
                    const rightEl = mirrorCloneX(el, el.name);
                    rightEl.name = rightEl.name.replace("left", "right");
                    servObj.allFiksatorRulonnikhMaterialov.push(rightEl);
                }
                servObj.allFiksatorRulonnikhMaterialov.push(el);
            }
            if (derzhatel_rulona__bokovoi.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allDerzhatelRulonaBokovoi";
                el.userData.activeFolderName = "activeDerzhatelRulonaBokovoi";
                el.userData.position = "top";

                if (Number(el.name.split("__").at(-1)) <= 1000) {
                    el.name += "__left";
                    const rightEl = mirrorCloneX(el, el.name);
                    rightEl.name = rightEl.name.replace("left", "right");
                    servObj.allDerzhatelRulonaBokovoi.push(rightEl);
                }
                servObj.allDerzhatelRulonaBokovoi.push(el);
            }
            if (rezak_rulonnikh_materialov.some((substr) => el.name.includes(substr) && !el.name.includes("mesh"))) {
                el.userData.allFolderName = "allRezakRulonnikhMaterialov";
                el.userData.activeFolderName = "activeRezakRulonnikhMaterialov";
                el.userData.position = "top";
                servObj.allRezakRulonnikhMaterialov.push(el);
            }
        });
    });
});

const loadPomeshenie = new Promise((resolve) => {
    loader.loadGLTF("./3d/esd_pomeshenie.glb", async (gltf) => {
        const glb = gltf.scene;

        const link = createLinkWithPath("textures");
        applyAOTexturesToGLB(glb, link);

        glb.traverse((_) => (_.visible = true));

        building = new BuildingWithDragControls(glb, scene);
        building.initBuildingSize();
        building.width = 8000;
        building.depth = 5000;
        building.height = 2600;
        building.wallDepth = 150;
        building.floorDepth = 75;
        building.initBuildingDragControls(activeCamera, renderer);
        servObj.building = building;

        const guideLines = new GuideLines(building, scene);
        guideLines.init();
        servObj.guideLines = guideLines;

        building.afterDragMove = (obj = servObj.active) => {
            if (obj) {
                if (servObj.isRedactorMode || servObj.isEditMode) return;
                guideLines.recalculateLinesPosition(obj, guideLines.findNeighbours(obj));
                guideLines.showLines();
            }
        };
        building.missClick = () => guideLines.hideLines();
        building.dragStart = () => guideLines.setPointerEvents("none");
        building.dragEnd = () => guideLines.setPointerEvents("auto");

        makeCSS2Dannotaition(guideLines.lines["L"], guideLines.updateSceneByInputEnter.bind(guideLines));
        makeCSS2Dannotaition(guideLines.lines["R"], guideLines.updateSceneByInputEnter.bind(guideLines));
        makeCSS2Dannotaition(guideLines.lines["T"], guideLines.updateSceneByInputEnter.bind(guideLines));
        makeCSS2Dannotaition(guideLines.lines["B"], guideLines.updateSceneByInputEnter.bind(guideLines));

        makeCSS2Dannotaition(servObj.building.floor);

        resolve(glb);
    });
});

Promise.all([loadElements, loadPomeshenie]).then(async ([one]) => {
    // Получим прайс и запишем его в window.price и обновим servObj.calc
    await getPrice().then(updatePrice);
    [
        "allTable",
        "stoyki_podkatnie",
        "stoli_podkatnie",
        "telezhki",
        "tumbi",
        "stellazhi",
        "stulya",
        "verstaki",
        "wardrobes",
    ].forEach((key) => {
        getPdfData(key).then((data) => {
            if (data) servObj.firstPdfPageData[key === "allTable" ? "tables" : key] = data;
        });
    });

    to3dView();
    setShadowBehaviour(one, [], []);
    setTableDefaultColor(servObj.allTableBazovii);
    wrapedAllObjectInAllArr();

    await loadPage();

    const urlParams = new URLSearchParams(window.location.search);
    const filename = urlParams.get("filename");

    if (filename) {
        const data = await getConfigOnServ(filename);
        await loadJSON(data);
    }

    globalLoader && (globalLoader.style.display = "none");
    const pageName = servObj.isRedactorMode ? "product" : "main";
    Tips.showOnce(pageName);
});

const clock = new THREE.Clock();

let lastWidth = container3D.offsetWidth;
let lastHeight = container3D.offsetHeight;
function animate() {
    ThreeMeshUI.update();
    if (building) building.updateBuildingSizeRotation();
    const deltaTime = clock.getDelta();

    requestAnimationFrame(animate);

    activeCamera.update(deltaTime);

    animations.update(deltaTime);

    materials.updatableMaterials.forEach((mat) => mat.animationUpdate(deltaTime));

    // Проверяем, изменился ли размер контейнера
    const curWidth = container3D.offsetWidth;
    const curHeight = container3D.offsetHeight;
    if (curWidth !== lastWidth || curHeight !== lastHeight) {
        onResize(servObj.scene.activeRenderer, servObj.scene.activeCamera, container3D);
        onResize(servObj.rendererAnn, servObj.scene.activeCamera, container3D);
        lastWidth = curWidth;
        lastHeight = curHeight;
    }
    scene.activeRenderer.render(scene, activeCamera);

    if (building) {
        building.wallsHider(activeCamera);
    }

    annRenderer.render(scene, activeCamera);
    // скрыть перекрываемые  аннотации при движении (используется raycaster, сильно тормозит приложение)
    // hideInvisibleAnns(activeCamera, servObj && servObj.annotations)
}
